var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/17f3e16492bc673ec53404177bb33c0a.js').default;export default
        Object.assign({}, scope_0 )
    